export default "__VITE_ASSET__336a1d8c__"